// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function decompte() {

    var self = this,
        $cache = {};
    var clock;

    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {      
        console.log('decompte');

        var eventTime, currentTime, duration, interval;
        interval = 1000; // 1 second
        // get time element
        var timerElement    = document.querySelector(".countdown");
        var yearElement     = document.querySelector(".years");
        var monthElement    = document.querySelector(".months");
        var dayElement      = document.querySelector(".days");
        var hourElement     = document.querySelector(".hours");
        var minElement      = document.querySelector(".minutes");
        var timer           = timerElement.dataset.timer+' 13:00';
        
        // calculate difference between two times
        eventTime = moment.tz(timer, "America/New_York");
        // based on time set in user's computer time / OS
        currentTime = moment.tz();
        // get duration between two times 
        duration = moment.duration(eventTime.diff(currentTime));
        
        timerElement.classList.remove("js-hidden");

        // loop to countdown every 1 second
        setInterval(function() {
            // get updated duration
            duration = moment.duration(duration - interval, 'milliseconds');
       
            yearElement.innerText = duration.years() < 10 ? '0'+ duration.years() : duration.years();
            monthElement.innerText = duration.months() < 10 ? '0'+ duration.months() : duration.months();
            dayElement.innerText = duration.days() < 10 ? '0'+ duration.days() : duration.days();
            hourElement.innerText = duration.hours() < 10 ? '0'+ duration.hours() : duration.hours();
            minElement.innerText = duration.minutes() < 10 ? '0'+ duration.minutes() : duration.minutes();
            
        }, interval);
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.decompte = decompte;
  
}(jQuery));
